import styled from "styled-components";

// TODO for a lot or rerenders

type AreaProps = { top?: number; bottom?: number; right?: number; left?: number };
export const AreaContainer = styled.div.attrs<AreaProps>(({ top, bottom, right, left }) => ({
  style: {
    borderTop: `${top}px solid rgba(0, 0, 0, 0.28)`,
    borderBottom: `${bottom}px solid rgba(0, 0, 0, 0.28)`,
    borderLeft: `${left}px solid rgba(0, 0, 0, 0.28)`,
    borderRight: `${right}px solid rgba(0, 0, 0, 0.28)`,
  },
}))<AreaProps>`
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

export const LeftTopCorner = styled.div`
  top: -0.25rem;
  left: -0.25rem;
  &:hover {
    cursor: nwse-resize;
  }
`;

export const RightTopCorner = styled.div`
  right: -0.25rem;
  top: -0.25rem;
  &:hover {
    cursor: nesw-resize;
  }
`;

export const LeftBottomCorner = styled.div`
  left: -0.25rem;
  bottom: -0.25rem;
  &:hover {
    cursor: nesw-resize;
  }
`;

export const RightBottomCorner = styled.div`
  bottom: -0.25rem;
  right: -0.25rem;
  &:hover {
    cursor: nwse-resize;
  }
`;

export const PrintBorder = styled.div`
  position: absolute;
  top: -0.0625rem;
  bottom: 0;
  left: -0.0625rem;
  right: -0.0625rem;
  border: 0.0625rem dotted rgba(255, 255, 255, 0.85);
  height: 100%;

  ${LeftTopCorner}, ${RightTopCorner}, ${LeftBottomCorner}, ${RightBottomCorner} {
    position: absolute;
    width: 0.3125rem;
    height: 0.3125rem;
    border: solid 0.125rem rgba(0, 0, 0, 0.7);
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.small};
    background-color: #ffffff;
    pointer-events: auto;
  }
`;
